import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingDecreasePictureSizeConfig } from '@/data/landingConfig/landingDecreasePictureSizeConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_DecreasePictureSize } from './schemaObject';

interface Props {}
const DecreasePictureSize: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_DecreasePictureSize} />
			<LandingTemplate
				data={landingDecreasePictureSizeConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageCompressor()}
			/>
		</>
	);
};

export default DecreasePictureSize;
